/**
 * Created by andreyna on 1/26/2017.
 */
const MY_ACCOUNT_POST_ACTIONS = {
    GAME: '1',
    CASHIER: '6',
    QUICK_DEPOSIT: '7',
    CASINO: '22',
    SPORT: '24',
    EXTERNAL_URL: '27',
    CLOSE: 'CloseMe',
    RICH: '56',
	INTERNAL_URL: '32'
}

export {MY_ACCOUNT_POST_ACTIONS};